function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_4324_812)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M9.02281 13.9422L6.95281 16.0122V8.7222C6.95281 8.2722 6.59281 8.0022 6.23281 8.0022C5.87281 8.0022 5.42281 8.2722 5.42281 8.7222V16.1022L3.35281 14.0322C3.08281 13.7622 2.54281 13.7622 2.27281 14.0322C2.00281 14.3022 2.00281 14.7522 2.27281 15.1122L5.60281 18.4422C5.87281 18.7122 6.32281 18.7122 6.68281 18.4422L10.0128 15.1122C10.1928 14.9322 10.1928 14.7522 10.1928 14.5722C10.1928 14.3922 10.1028 14.2122 10.0128 14.0322C9.83281 13.6722 9.38281 13.6722 9.02281 13.9422Z",
  fill: "#00C4B5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.9535 4.2222L12.6235 0.892197C12.3535 0.622197 11.9035 0.622197 11.5435 0.892197L8.12351 4.2222C7.94351 4.3122 7.85351 4.5822 7.94351 4.7622C7.94351 4.9422 8.03351 5.1222 8.12351 5.3022C8.39351 5.5722 8.84351 5.5722 9.20351 5.3022L11.2735 3.2322V10.5222C11.2735 10.9722 11.6335 11.2422 11.9935 11.2422C12.4435 11.2422 12.7135 10.8822 12.7135 10.5222V3.2322L14.7835 5.3022C15.0535 5.5722 15.5935 5.5722 15.8635 5.3022C16.2235 4.9422 16.2235 4.4922 15.9535 4.2222Z",
  fill: "#00C4B5"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_4324_812"
}, /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 18,
  fill: "white",
  transform: "translate(0.113281 0.622192)"
})));

function SvgSortIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortIcon);
export default __webpack_public_path__ + "static/media/SortIcon.64b82946.svg";
export { ForwardRef as ReactComponent };